import { ActivityItem, Icon, Link, mergeStyleSets } from "@fluentui/react";
import { FunctionComponent } from "react";

interface AccionesMejoraVistaProps {
  TareaId: string;
}

const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
  },
  nameText: {
    fontWeight: "bold",
  },
});

const activityItemExamples = [
  {
    key: 1,
    activityDescription: [
      <Link key={1} className={classNames.nameText}>
        Bueno Gutierrez Denis
      </Link>,
      <span key={2}> : Responsable</span>,
    ],
    activityIcon: <Icon iconName={"ReminderPerson"} />,
    comments: [
      <span key={1}>Accion : </span>,
      <Link key={2} className={classNames.nameText}>
        Realizar limpieza al area de trabajo
      </Link>,
    ],
    timeStamp: "Plazo : 4 dias",
  },
];
const AccionesMejoraVista: FunctionComponent<AccionesMejoraVistaProps> = () => {
  return (
    <>
     <span key={1}>Tarea : Labores de oficina</span>
     <br />
      <div>
        {activityItemExamples.map((item: { key: string | number }) => (
          <>
            <br />
            <br />
            <ActivityItem
              {...item}
              key={item.key}
              // className={classNames.exampleRoot}
            />
          </>
        ))}
      </div>
    </>
  );
};

export default AccionesMejoraVista;
